import pageService from '@api/modules/pageService'
import i18n from '@config/i18n/i18n'
import router from '@config/router/router';

export default {
  state: {
    page: {},
  },
  mutations: {
    setPage(state, page) {
      state.page = page;
    },
  },
  actions: {
    getPage({
      commit,
      state
    }, slug) {
      pageService.get(slug).then(res => {
        let breadObject = {
          name: "Breadcrumbs",
          payload: {
            afterHero: false,
            current: res.data.title,
          }
        };
        if (res.data.partials.length) {
          if (res.data.partials[0].name === 'HeroComponent') {
            breadObject.payload.afterHero = true;
            res.data.partials.splice(1, 0, breadObject);
          } else {
            res.data.partials.splice(0, 0, breadObject);
          };
        }
        commit('setPage', res.data);
      }, err => {
        router.push({
          name: '404'
        });
        throw new Error(err);
      })
    }
  },
  getters: {
    getPage: state => {
      return state.page
    },
    getPageSlugByLocale: state => locale => {
      return state.page.slug[locale]
    },
  }
}